var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"cover",staticClass:"cover"},[_c('progressive-background',{staticClass:"inner",attrs:{"placeholder":"/images/cover.jpg","src":"/images/cover.jpg","no-ratio":""}})],1),_c('div',{ref:"spacer"})])}
var staticRenderFns = []

export { render, staticRenderFns }